import script from "./ChangeStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeStatus.vue?vue&type=script&setup=true&lang=js"

import "./ChangeStatus.vue?vue&type=style&index=0&id=453c9b5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-453c9b5a"]])

export default __exports__